/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeoJsonDataModelApiModel } from '../../models/geo-json-data-model-api-model';

export interface GetStateBoundriesByCoordinates$Params {
  lng: any;
  lat: any;
}

export function getStateBoundriesByCoordinates(http: HttpClient, rootUrl: string, params: GetStateBoundriesByCoordinates$Params, context?: HttpContext): Observable<StrictHttpResponse<GeoJsonDataModelApiModel>> {
  const rb = new RequestBuilder(rootUrl, getStateBoundriesByCoordinates.PATH, 'get');
  if (params) {
    rb.path('lng', params.lng, {});
    rb.path('lat', params.lat, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeoJsonDataModelApiModel>;
    })
  );
}

getStateBoundriesByCoordinates.PATH = '/v1/lookup/boundries/{lat}/{lng}';
